import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import classes from './addEditGeneralAd.module.scss';
import { IGeneralAdStore } from '../../mobx-store/storeInterfaces/generalAdInterface';

interface IProps extends WithSnackbarProps {
  generalAdsStore: IGeneralAdStore;
  countryStore: CountryStore;
  match: any;
  history: any;
}

interface IState {
  formFields: FormField[];
  loading: boolean;
  processing: boolean;
  open: boolean;
}

@inject('generalAdsStore')
@inject('countryStore')
@observer
class AddEditGeneralAd extends Component<IProps & RouteComponentProps, IState> {

  isNew = false;

  generalAdId = -1;

  isEgypt = false;

  pageTitle = '';

  lastHistory = -1;

  generalAdFormTitle = '';

  generalAdSchema: any;

  submitButton: any;

  cancelButton: any;

  handleAgree: () => void = () => null;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  async componentWillMount() {
    await this.props.countryStore.getUserManagedCountries();
  }

  initializeComponent(props: IProps & RouteComponentProps, isConstructor = true) {
    this.props.generalAdsStore.filesConflictError = false;
    if (props.match.params.id) {
      this.isNew = false;
      this.generalAdId = props.match.params.id;
      this.pageTitle = translate('editGeneralAdPageTitle', {});
    } else {
      this.isNew = true;
      this.pageTitle = translate('newGeneralAdPageTitle', {});
    }
    this.initAdSchema();
    this.initState(isConstructor);
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    this.generalAdFormTitle = translate('generalAdPageFormTitle', {});
  }

  initAdSchema = () => {
    this.generalAdSchema = Yup.object().shape({
      title: Yup.string().required('Required'),
      isActive: Yup.boolean().default(false),
      videoURL: Yup.string(),
      imageURL_en: Yup.string(),
      imageURL_ar: Yup.string(),
      widgetImageURL_en: Yup.string().required('Required'),
      widgetImageURL_ar: Yup.string().required('Required'),
    })
  };

  getFormFields = (): FormField[] => {

    return [
      {
        name: 'title',
        label: translate('generalAdTitleInuptArabicTitle', {}),
        type: 'text',
        filedType: 'InputField',
      },
      {
        name: 'widgetImageURL_ar',
        label: translate('generalWidgetImageURL_arPageFormImage', {}),
        filedType: 'GalleryField',
        isLimitToOneImage: true,
        accept: 'image/*',
        size: 200,
      },
      {
        name: 'widgetImageURL_en',
        label: translate('generalWidgetImageURL_enPageFormImage', {}),
        filedType: 'GalleryField',
        isLimitToOneImage: true,
        accept: 'image/*',
        size: 200,
      },
      {
        name: 'videoURL',
        label: translate('generalAdVideoInuptArabicTitle', {}),
        filedType: 'GalleryField',
        isLimitToOneImage: true,
        accept: 'video/*',
        textMessage: translate('addVideoTextMessage', {}),
      },
      {
        name: 'imageURL_ar',
        label: translate('generalAdImageURL_arPageFormImage', {}),
        filedType: 'GalleryField',
        isLimitToOneImage: true,
        accept: 'image/*',
        size: 200,
      },
      {
        name: 'imageURL_en',
        label: translate('generalAdImageURL_enPageFormImage', {}),
        filedType: 'GalleryField',
        isLimitToOneImage: true,
        accept: 'image/*',
        size: 200,
      },
    ];
  };

  initState = async (isConstructor = true) => {
    const initState: IState = {
      open: false,
      processing: false,
      loading: true,
      formFields: this.getFormFields(),
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };

  handleSubmit = (values: any): void => {
    const { generalAdsStore } = this.props;
    if((values.videoURL.length > 0 && values.imageURL_ar.length === 0 && values.imageURL_en.length === 0) || 
    (values.imageURL_ar.length > 0 && values.imageURL_en.length > 0 && values.videoURL.length === 0)) {
      this.setState({
        processing: true,
        loading: true
      });  
      this.props.generalAdsStore.selectedGeneralAd = {...this.props.generalAdsStore.selectedGeneralAd, values};
      this.props.generalAdsStore.filesConflictError = false;
      this.updateStateWithAdData();
      if (this.isNew) {
        try {
          generalAdsStore.createGeneralAd(values, this.props.countryStore.managedCountries)
            .then(() => {
              this.props.history.goBack();
              SnackBarComponent.getInstance().openSnackbar(translate('createdMessage', {
              }), 5000, 'success');
            });
        } catch (error) {
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 5000, 'error');
        } finally {
          this.setState({
            processing: false,
            loading: false
          });
        }
      } else {
        this.props.generalAdsStore.updateGeneralAd({...values, generalAdId: this.generalAdId}, this.props.countryStore.managedCountries)
          .then(() => {
            SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
            }), 5000, 'success');
            this.props.history.goBack();
          }).catch((error) => {
           SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
            }), 5000, 'error');
          }).finally(() => {
            this.setState({
              processing: false,
              loading: false
            });
          });
      }  
    } else {
      this.props.generalAdsStore.filesConflictError = true;
    }
  };

  handleCancel = (): void => {
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: 'Save Changes',
    onSubmit: this.handleSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.handleCancel,
  });

  updateStateWithAdData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      formFieldsWithData.push({
        ...field, 
        value: this.props.generalAdsStore.selectedGeneralAd[field.name]
      });
    }
    this.setState({
      formFields: formFieldsWithData, 
      loading: false,
    });
  };

  render() {

    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <IconButton
            className={classes.backButton}
            onClick={() => this.props.history.goBack()}
            aria-label="Back"
          >
            <KeyboardArrowLeft />
          </IconButton>
          <Typography className={classes.title} variant="h6" gutterBottom>
            {this.pageTitle}
          </Typography>
        </div>
        <div className={classes.content}>
          {
            this.props.generalAdsStore.filesConflictError && <p className={classes.error}>{translate('filesConflictError', {})}</p>
          }
          {
            this.state.loading || this.props.generalAdsStore.loading
              ? <Spinner />
              : (
                <GeneralFormComponent
                  dropdownLanguages={null}
                  formTitle={this.generalAdFormTitle}
                  fields={this.state.formFields}
                  formSchema={this.generalAdSchema}
                  submitButton={this.submitButton}
                  cancelButton={this.cancelButton}
                  processing={this.state.processing}
                />
              )
          }
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.initState(false);
    this.submitButton = this.getSubmitButton();
    if (!this.isNew) {
      this.props.generalAdsStore.getGeneralAdById(this.generalAdId)
        .then(() => {
          this.updateStateWithAdData();
          if (this.props.history.location.from) {
            this.lastHistory = -2;
          }
        }).catch(() => {
          this.setState({
            loading: false,
          });      
        });
    } else {
      this.setState({
          loading: false,
        });    
    }
  }

}

export default withRouter(AddEditGeneralAd);
